import type { MarginIntel } from '@siliconx/shared';
import { formatUsd } from '@siliconx/shared/ui/format';
import { toInlineMarginFromIntel } from '../../lib/inlineMargin';

/**
 * SIL-2543: compact Break-even / At target / Best month figures for one row.
 * `unavailable` renders a dash on asset rows; on listing rows (`hideWhenUnavailable`)
 * it renders nothing, so an unverified buyer's card is unchanged.
 */
export function InlineMarginFigures({
  intel,
  hideWhenUnavailable = false,
}: {
  intel: MarginIntel | undefined;
  hideWhenUnavailable?: boolean;
}) {
  const m = toInlineMarginFromIntel(intel);
  const unavailable = m.bestMonth === null;
  if (unavailable && hideWhenUnavailable) return null;
  if (unavailable) {
    return (
      <span data-testid="inline-margin-unavailable" className="text-xs text-zinc-400">
        —
      </span>
    );
  }
  return (
    <span data-testid="inline-margin" className="inline-flex flex-col text-xs text-zinc-700">
      <span>
        Break-even <span className="font-medium">{formatUsd(m.breakEvenBidUsd)}</span>
      </span>
      <span>
        At target <span className="font-medium">{formatUsd(m.bidAtTargetMarginUsd)}</span>
      </span>
      <span className="text-zinc-500">
        {m.bestMonth === 0 ? 'Sell now' : `Best month ${m.bestMonth}`}
        {m.confidenceGrade ? ` (${m.confidenceGrade})` : ''}
      </span>
    </span>
  );
}
